export default "__VITE_ASSET__6vEyGoEg__"